import React from 'react';


export const AgentThinkingIndicator = ({stepLabel}) => {
    return (
        <div className="agent-bubble__row agent-bubble__row--left">
            <div className="agent-bubble__avatar agent-bubble__avatar--assistant">
                <i className="fas fa-robot"></i>
            </div>
            <div className="agent-thinking">
                <div className="agent-thinking__dots">
                    <span className="agent-thinking__dot"></span>
                    <span className="agent-thinking__dot"></span>
                    <span className="agent-thinking__dot"></span>
                </div>
                {stepLabel && (
                    <span className="agent-thinking__label">{stepLabel}</span>
                )}
            </div>
        </div>
    );
};
